import * as R from 'ramda'

import {
    FETCH_MAIN_DATA,
} from '../types'
  
const initialState = {};

export default function maindata(state = initialState, {type,payload}) {
    switch (type) {
        case FETCH_MAIN_DATA:
            return R.merge(state, payload)
        default:
            return state;
    }
}